export const RegulationTypes = Object.freeze({
    RBI: 'rbi',
    SEBI: 'sebi',
});